import { getAgenticBaseUrl } from 'utils/agenticUrl'
import { deleteRest, get, post } from 'utils/rxfetch'

export default {
  // this is correct we send eid, but agentic themis expects names is report_id
  generateAgentToken(reportId, companyId = '', reportType) {
    return post(`/members-api/themis/agent/token?companyFilter=${companyId}`, {
      report_id: reportId,
      report_type: reportType,
    })
  },
  generateStatusToken() {
    return post(`/members-api/themis/agent/status-token`, {})
  },
  getAgentTrialStatus(companyId = '') {
    return get(`/members-api/themis/agent/trial?companyFilter=${companyId}`)
  },
  activateAgentTrial(companyId = '') {
    return post(`/members-api/themis/agent/trial?companyFilter=${companyId}`, {})
  },
  deactivateAgentTrial(companyId = '') {
    return deleteRest(`/members-api/themis/agent/trial?companyFilter=${companyId}`)
  },
  getAgentStatusBatch(statusToken, eids, url) {
    const baseUrl = getAgenticBaseUrl(url)
    return post(
      `${baseUrl}/api/v1/agent-status/batch`,
      { report_ids: eids },
      { Authorization: `Bearer ${statusToken}` }
    )
  },
  // The credit balance comes from creditManagement.getBillingStatus() — the
  // agentic service no longer serves /api/v1/company-credits (404).
  getIncidentIdWithThemisSummary(companyId = '') {
    return get(`/members-api/latest-themis/report?companyFilter=${companyId}`)
  },
}
